import { DataTable } from '@cartwheel/components'
import type { Appointment } from './appointment-row'

export interface HealthieRecordRowProps {
  appointment: Appointment
  copiedId: string | null
  onCopyHealthieId: (id: string) => void
}

export function HealthieRecordRow({
  appointment,
  copiedId,
  onCopyHealthieId,
}: HealthieRecordRowProps) {
  if (!appointment.has_ehr_record) return null

  return (
    <DataTable.Row className="!bg-gray-50">
      <DataTable.Cell colSpan={5} className="!py-2 px-6 text-sm">
        <span className="inline-flex items-center gap-2">
          {appointment.healthie_resource_id ? (
            <>
              <i className="fa-solid fa-check text-forest" />
              <span className="font-medium">Healthie:</span>
              <button
                type="button"
                onClick={() => {
                  if (appointment.healthie_resource_id) {
                    onCopyHealthieId(appointment.healthie_resource_id)
                  }
                }}
                className="text-forest underline hover:text-forest-dark cursor-pointer"
                title="Click to copy Healthie ID"
              >
                {appointment.healthie_resource_id}
              </button>
              {copiedId === appointment.healthie_resource_id && (
                <span className="text-forest text-xs font-medium">Copied!</span>
              )}
            </>
          ) : (
            <>
              <i className="fa-solid fa-triangle-exclamation text-orange" />
              <span className="font-medium text-orange">Healthie:</span>
              <span className="text-orange">Missing Healthie ID</span>
            </>
          )}
        </span>
      </DataTable.Cell>
    </DataTable.Row>
  )
}
